import axios from "@/plugins/axios.js"
import api from "@/api.js"
export default new class Dashboard{
	constructor(){
		this.listDetails = [];
	}
	getListDetails(){
		return this.listDetails;
	}
	async getList(pg=1){
		try{
			if (api) {				
				const uri = `${api.url}/api/v1/dashboard`;					
				const data = await axios.get(uri);							
				return data;
			}
		}catch(er){
			console.warn("Error get Dashboard ", er)
			return er;
		}
		return null;
	}
	async saveDashboard(params){
		try{
			if (api) {				
				const uri = `${api.url}/api/v1/dashboard`;					
				const data = await axios.post(uri, params);							
				return data;
			}
		}catch(er){
			console.warn("Error save Dashboard ", er)
			return er;
		}
		return null;
	}
	async updateDashboard(params){
		console.log("🔄 updateDashboard service llamado con params:", params);
		try{
			if (api) {
				const uri = `${api.url}/api/v1/dashboard/${params.id}`;
				console.log("🚀 Enviando PUT request a:", uri);
				console.log("📦 Datos enviados:", params);
				const data = await axios.put(uri, params);
				console.log("✅ Respuesta del servidor:", data);
				return data;
			} else {
				console.error("❌ ERROR: API no disponible");
				throw new Error("API no disponible");
			}
		}catch(er){
			console.error("❌ ERROR en updateDashboard service:", er);
			return er;
		}
		return null;
	}
	
	async deleteDashboard(params){
		try{
			if (api) {				
				const uri = `${api.url}/api/v1/dashboard/${params.id}`;					
				const data = await axios.delete(uri);							
				return data;
			}
		}catch(er){
			console.warn("Error save Dashboard ", er)
			return er;
		}
		return null;
	}
	async getListFor(pg=1){		
		try{
			let isLoadingReq = true;
			while(isLoadingReq){
				const res =  await this.getList(pg);
				if (res && res.data && res.data.rows.length > 0) {						
					this.listDetails 		= this.listDetails.concat(res.data.rows);// temp_list;					
				}		
				if (parseInt(res.data.pages) > pg) {
					pg++;					
				}else{
					isLoadingReq = false;
					return this.listDetails;
				}
			}			
		}catch(er){
			console.warn("Error get ListDetailsService ", er)
			return er;
		}
		
	}
}